export default __webpack_public_path__ + "static/media/stripes.44e8e46d.jpg";